import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import cx from 'classnames';
import { IconSettings } from '@xingternal/icons';
import { spaceM } from '@xingternal/tokens';
import { Label } from '@xingternal/label';
import { Toggle } from '@xingternal/toggle';

import {
  setDefaultAllowAutoplayState,
  getAllowAutoplayState,
} from '../../settings';

import styles from './styles.css';

/* Note: We are forcing to read the getAllowAutoplayState value everytime that the user expands the settings
and we are collapsing the settings after a few seconds to be sure that it's consistent when using multiple players */
class AutoplaySettings extends React.Component {
  state = { isOpen: false, isEnabled: getAllowAutoplayState() };

  expandCollapseHandler = (shouldExpand = !this.state.isOpen) => {
    if (shouldExpand) {
      this.timer = setTimeout(() => this.expandCollapseHandler(false), 5000);
    } else {
      this.timer && clearTimeout(this.timer);
      this.timer = null;
    }
    this.setState({ isOpen: shouldExpand, isEnabled: getAllowAutoplayState() });
  };

  autoplayToggle = () => {
    const isEnabled = !this.state.isEnabled;
    this.setState({ isEnabled });
    setDefaultAllowAutoplayState(isEnabled);
  };

  render() {
    return (
      <div
        className={cx(
          styles.container,
          { [styles.autoplayExpanded]: this.state.isOpen },
          { [styles.autoplayEnabled]: this.state.isEnabled }
        )}
      >
        <div className={styles.toggleContainer}>
          <Label>
            <Toggle
              className={cx(styles.toggle, 'xing-vjs-autoplay-toggle')}
              on={this.state.isEnabled}
              onChange={this.autoplayToggle}
            />
            <span style={{ marginLeft: spaceM }}>
              <FormattedMessage
                id="VIDEOS_AUTOPLAY"
                defaultMessage="Autoplay"
              />
            </span>
          </Label>
        </div>
        <button
          className={cx(
            styles.expandCollapseButton,
            'xing-vjs-settings-button'
          )}
          type="button"
          onClick={() => this.expandCollapseHandler()}
        >
          <div className={styles.icon}>
            <IconSettings width={19} height={19} />
          </div>
        </button>
      </div>
    );
  }
}

AutoplaySettings.propType = {
  intl: PropTypes.any,
};

export default AutoplaySettings;
